if (!customElements.get('benefits-media-accordion')) {
  customElements.define('benefits-media-accordion', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.benefits-with-media__item')];
      this.animations = new WeakMap();
      let hasOpenItem = false;
      // The controller manages exclusivity so the outgoing item can finish
      // its collapse instead of being hidden immediately by the browser.
      for (const item of this.items) {
        if (item.dataset.motionState === 'closing') item.open = false;
        delete item.dataset.motionState;
        if (item.open) {
          if (hasOpenItem) item.open = false;
          else hasOpenItem = true;
        }
        item.removeAttribute('name');
      }
      this.onClick = event => {
        const summary = event.target.closest('summary');
        const item = summary?.parentElement;
        if (!item || !this.contains(item)) return;
        event.preventDefault();
        const shouldOpen = item.dataset.motionState === 'closing' || !item.open;
        if (shouldOpen) this.items.filter(other => other !== item && other.open).forEach(other => this.setOpen(other, false));
        this.setOpen(item, shouldOpen);
      };
      this.onBlockSelect = event => {
        const item = this.items.find(candidate => candidate.dataset.shopifyEditorBlock === event.detail?.blockId || candidate.contains(event.target));
        if (item && this.contains(item)) {
          this.items.filter(other => other !== item && other.open).forEach(other => this.setOpen(other, false));
          this.setOpen(item, true);
        }
      };
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.items?.forEach(item => {
        this.animations.get(item)?.cancel();
        if (item.dataset.motionState === 'closing') item.open = false;
        delete item.dataset.motionState;
      });
    }
    setOpen(item, shouldOpen) {
      const panel = item.querySelector('.benefits-with-media__panel');
      const previousAnimation = this.animations.get(item);
      const currentHeight = panel?.getBoundingClientRect().height || 0;
      previousAnimation?.cancel();
      this.animations.delete(item);
      delete item.dataset.motionState;
      if (!panel || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        item.open = shouldOpen;
        return;
      }
      if (shouldOpen && item.open && !previousAnimation) return;
      if (!shouldOpen && !item.open) return;
      if (shouldOpen) item.open = true;
      const fullHeight = panel.scrollHeight;
      const from = shouldOpen ? (previousAnimation ? currentHeight : 0) : currentHeight;
      const to = shouldOpen ? fullHeight : 0;
      item.dataset.motionState = shouldOpen ? 'opening' : 'closing';
      const animation = panel.animate(
        [{ height: `${from}px`, opacity: shouldOpen && !previousAnimation ? 0 : 1 },
          { height: `${to}px`, opacity: shouldOpen ? 1 : 0 }],
        { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' }
      );
      this.animations.set(item, animation);
      animation.finished.then(() => {
        if (this.animations.get(item) !== animation) return;
        this.animations.delete(item);
        delete item.dataset.motionState;
        item.open = shouldOpen;
      }).catch(() => {});
    }
  });
}
